import React from "react"

import { mdiOpenInNew } from "@mdi/js"
import {
	Box,
	Drawer,
	List
} from "@mui/material"
import {
	createTheme,
	ThemeProvider,
} from "@mui/material/styles"

import { darkTheme } from "commons/themes"

import { Config } from "Config"
import { RoutesData } from "components/commons"
import { AccountType, SessionResponse } from "models"
import {
	SidebarItem,
	SidebarItemSelectionMode,
} from "structure/sidebar/sidebar-item"
import logo from "./logo_no_bg.svg"

interface SidebarProps {
	width: number | string
	sessionData: SessionResponse
}
interface SidebarState {
	mobileOpen: boolean
}
export class Sidebar extends React.Component<SidebarProps, SidebarState> {
	private readonly config = Config.init()

	private readonly drawerTheme = createTheme(darkTheme, {
		components: {
			MuiDrawer: {
				styleOverrides: {
					paper: {
						backgroundImage: "unset",
					},
				},
			},
			MuiListItemText: {
				styleOverrides: {
					root: {
						"& span": {
							fontSize: "0.75em",
							marginLeft: "-20px",
						},
					},
				},
			},
			MuiListItem: {
				defaultProps: {
					disablePadding: true,
				},
			},
			MuiListItemButton: {
				styleOverrides: {
					root: {
						"&.Mui-selected": {
							backgroundColor: "#0b255a"
						},
					},
				},
			},
		},
	})

	constructor(props: any) {
		super(props)
		this.state = {
			mobileOpen: false,
		}
	}

	public handleDrawerToggle = () => {
		this.setState({ mobileOpen: !this.state.mobileOpen })
	}

	public render() {

		const drawer = (
			<>
				<Box component={"img"} src={logo} sx={{
					height: 64,
					display: "block",
					margin: "0 auto",
					padding: 1,
				}} />

				<List disablePadding>
					<SidebarItem selected={SidebarItemSelectionMode.EXACT} data={RoutesData.DASHBOARD} />
					<SidebarItem data={RoutesData.NOTIFICATIONS} />
					<SidebarItem data={RoutesData.ACTIONS} />
					{this.props.sessionData.accountType === AccountType.LANDLORD &&
						<>
							<SidebarItem data={RoutesData.ASSET_LIST} />
						</>}
					{/* Actions for ADMIN */}
					{this.props.sessionData.accountType === AccountType.ADMIN &&
						<>
							<SidebarItem data={RoutesData.WORKFLOW} />
							<SidebarItem data={RoutesData.ASSET_LIST} />
							<SidebarItem data={RoutesData.MATCH_PROPOSAL} />
							<SidebarItem data={RoutesData.CONTRACT} />
							<SidebarItem data={RoutesData.MICROJOB} />
							<SidebarItem data={RoutesData.MICROJOB_JOBS} />
							<SidebarItem data={RoutesData.BRAND_LIST} />
							<SidebarItem data={RoutesData.USER} />
							<SidebarItem data={RoutesData.DOCUMENTS} />
							{/*<SidebarItem data={RoutesData.ECONOMIC_MANAGEMENT} />*/}
							{/*<SidebarItem to="/reports" disabled icon={mdiChartArc} title="Reportistica e Analytics" />*/}
						</>
					}

					{/* Actions for BRAND */}
					{this.props.sessionData.accountType === AccountType.BRAND &&
						<>
							<SidebarItem data={RoutesData.RESEARCH} />
							<SidebarItem data={RoutesData.PROPOSALS} />
							<SidebarItem data={RoutesData.FAVOURITES} />
							{/*<SidebarItem to="/wip" disabled icon={mdiStoreSettingsOutline} title="Immobili in qualificazione" />*/}
							{/*<SidebarItem data={RoutesData.AFFILIATES} />*/}
						</>
					}

					{/*<SidebarItem data={RoutesData.SUPPORT_AND_DOCUMENTATION} />*/}
					<SidebarItem
						externalHref={this.config.scan360Url}
						highlighted
						icon={mdiOpenInNew}
						title="Scraper Immobili"
					/>
				</List>

				{/*<CustomWidthTooltip title={*/}
				{/*	<Typography color="inherit" textAlign="center" sx={{fontSize: "0.8rem"}}>*/}
				{/*		Ciao!<br />Sono il tuo assistente virtuale.<br />Come posso aiutarti oggi?*/}
				{/*	</Typography>*/}
				{/*} arrow placement={"top"} >*/}
				{/*	<Box component={"img"}*/}
				{/*		src={bot}*/}
				{/*		sx={{*/}
				{/*			height: 80,*/}
				{/*			display: "block",*/}
				{/*			position: "absolute",*/}
				{/*			bottom: 30,*/}
				{/*			alignSelf: "center",*/}
				{/*		}}*/}
				{/*	/>*/}
				{/*</CustomWidthTooltip>*/}
			</>
		)

		const container = window !== undefined ? () => window.document.body : undefined
		return (
			<Box
				component="nav"
				sx={{ width: { xl: this.props.width }, flexShrink: { xl: 0 } }}
			>
				<ThemeProvider theme={this.drawerTheme}>
					<Drawer
						container={container}
						variant="temporary"
						open={this.state.mobileOpen}
						onClose={this.handleDrawerToggle}
						ModalProps={{
							keepMounted: true,
						}}
						sx={{
							display: { xs: 'block', xl: 'none' },
							'& .MuiDrawer-paper': { boxSizing: 'border-box', width: this.props.width },
						}}
					>
						{drawer}
					</Drawer>
					<Drawer
						variant="permanent"
						sx={{
							display: { xs: 'none', xl: 'block' },
							'& .MuiDrawer-paper': { boxSizing: 'border-box', width: this.props.width },
						}}
						open
					>
						{drawer}
					</Drawer>
				</ThemeProvider>
			</Box>
		)
	}
}
